import { GlobalState } from '../store'
import { createSelector, Selector, UnknownAction } from '@reduxjs/toolkit'
import { systemStoreSelector } from './storeSelectors'

export function createActionLogSelector(): Selector<GlobalState, UnknownAction[]> {
  return createSelector(systemStoreSelector, systemStore => {
    return systemStore.actionLog
  })
}
